import { render, staticRenderFns } from "./AddressLookupComponent.vue?vue&type=template&id=08bb7e6a"
import script from "./AddressLookupComponent.vue?vue&type=script&lang=ts"
export * from "./AddressLookupComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports